// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3i78E","modalForm":"UpgradeEpcsModal_modalForm__1sJCQ","modalFooter":"UpgradeEpcsModal_modalFooter__3rkv2"};